import { axiosObject } from "../config";

export default function requestVerification(form: any) {
  let payload = {
    type: "email",
    value: form.value.email.toLocaleLowerCase(),
  };

  return new Promise((resolve, reject) => {
    let uri = "access/request-verify-registration";

    axiosObject
      .post(uri, payload)
      .then((response) => {
        console.log("check here res:", response);
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
